export const state = () => ({
  modal: {
    isOpen: false,
    offerData: null
  }
});

export const getters = {
  modal: state => state.modal
};
export const actions = {
  openModal({ commit }, payload) {
    commit("SET_MODAL_OFFER_DATA", payload);
    commit("SET_MODAL_OPEN", true);
  },
  closeModal({ commit }) {
    commit("SET_MODAL_OPEN", false);
    commit("SET_MODAL_OFFER_DATA", null);
  }
};

export const mutations = {
  SET_MODAL(state, payload) {
    state.modal = payload;
  },
  SET_MODAL_OPEN(state, payload) {
    state.modal.isOpen = payload;
  },
  SET_MODAL_OFFER_DATA(state, payload) {
    state.modal.offerData = payload;
  }
};
